const MODULE_ACTION_RULES = {
  statistics: {
    allowed: ["view"],
    defaults: [],
  },
  "rooms-history": {
    allowed: ["view"],
    defaults: [],
  },
  models: {
    allowed: ["view"],
    defaults: [],
  },
  default: {
    allowed: [],
    defaults: [],
  },
};

const normalizeModuleKey = (moduleKey) => (moduleKey || "default").toString().toLowerCase();

const APP_SUBMODULES = {
  statistics: [
    { module: "statistics", title: "Producción" },
    { module: "models", title: "Modelos", icon: "users" },
    { module: "rooms-history", title: "Ocupación" },
  ],
  default: [],
};

export const getAllowedActionsForModule = (moduleKey) => {
  const key = normalizeModuleKey(moduleKey);
  return MODULE_ACTION_RULES[key]?.allowed || MODULE_ACTION_RULES.default.allowed;
};

export const getDefaultActionsForModule = (moduleKey) => {
  const key = normalizeModuleKey(moduleKey);
  return MODULE_ACTION_RULES[key]?.defaults || MODULE_ACTION_RULES.default.defaults;
};

export const getSubmodulesForApp = (appKey) => {
  const key = normalizeModuleKey(appKey);
  return APP_SUBMODULES[key] || APP_SUBMODULES.default;
};
